import { render, staticRenderFns } from "./QaListItemOwnerActions.vue?vue&type=template&id=0e04c05e&scoped=true&"
import script from "./QaListItemOwnerActions.vue?vue&type=script&lang=js&"
export * from "./QaListItemOwnerActions.vue?vue&type=script&lang=js&"
import style0 from "./QaListItemOwnerActions.vue?vue&type=style&index=0&id=0e04c05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e04c05e",
  null
  
)

export default component.exports